import React from 'react';
import { name } from './constants';
import { Link } from 'react-router-dom';
import { Can } from 'auth';
import { userPermissions } from 'constants/userPermissions';

const SubNavigation = () => {
  return (
    <div>
      <p>
        <Link to={`/${name}/billing-statements`}>Billing Statements</Link>
      </p>
      <p>
        {/* Master bills only available for Arch Admin */}
        <Can
          perform={userPermissions.MANAGE_BILL}
          yes={() => <Link to={`/${name}/master-bills`}>Master Bills</Link>}
        />
      </p>
    </div>
  );
};

export default SubNavigation;
